import { Link } from "react-router-dom";
import Slider from "react-slick";
import { useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import DynamicBreadcrumb from "./DynamicBreadcrumb";

const DynamicBanner = ({
  title,
  bgImage = [],
  bgImageMobile = [],
  buttons = [],
}) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const images = isMobile
    ? Array.isArray(bgImageMobile)
      ? bgImageMobile
      : [bgImageMobile]
    : Array.isArray(bgImage)
      ? bgImage
      : [bgImage];

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
  };

  return (
    <div className="alumni_banner">
      <section className="breadcrump_section">
        <Slider {...sliderSettings} className="banner-slider">
          {images.length > 0 ? (
            images.map((img, index) => (
              <div key={index} className="banner-slider">
                <img
                  src={`${process.env.REACT_APP_API_URL}/public${img}`}
                  alt={`Banner ${index + 1}`}
                  className="img-fluid"
                />
              </div>
            ))
          ) : (
            <div className="banner-slider">
              <img
                src="/assets/images/default-banner.webp"
                alt="Default Banner"
                className="img-fluid"
              />
            </div>
          )}
        </Slider>

        <div className="breadcrump-wrapper">
          <h1 className="breadcrump-heading">{title}</h1>

          <div className="d-flex flex-wrap gap-3 mt-3">
            {buttons.map((btn, idx) => (
              <Link to={btn.link} key={idx} className="btn apply-new-btn">
                {btn.icon && (
                  <i className={btn.icon} style={{ marginRight: "8px" }}></i>
                )}
                {btn.text}
              </Link>
            ))}
          </div>
        </div>

        <DynamicBreadcrumb />
      </section>
    </div>
  );
};

export default DynamicBanner;
